// © Microsoft Corporation. All rights reserved.

import { CommonStyles, CommonSuperAppStyles } from "@msnews/social-utils";

import { CommentBoxStyles } from "./comment/comment-box/CommentBox.styles";
import { CommentItemStyles } from "./comment/comment-item/CommentItem.styles";
import { CommentListStyles } from "./comment/comment-list/CommentList.styles";
import { CommentStyles } from "./comment/Comment.styles";
import { CommentSuperAppStyles } from "./comment/themes/superapp/CommentSuperApp.styles";
import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { ContentPanelStyles } from "./comment/content-panel/ContentPanel.styles";
import { DeleteMenuMenuStyles } from "./common/delete-menu/DeleteMenu.styles";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { DisabledMessageStyles } from "./comment/disabled-message/DisabledMessage.styles";
import { FollowButtonStyles } from "./follow-button/FollowButton.styles";
import { FollowButtonSuperAppStyles } from "./follow-button/themes/superapp/FollowButtonSuperApp.styles";
import { MiniReactionBreakdownStyles } from "./common/mini-reaction-breakdown/MiniReactionBreakdown.styles";
import { MostReactionsStyles } from "./common/most-reactions/MostReactions.styles";
import { ProfileEducatorStyles } from "./comment/profile-educator/ProfileEducator.styles";
import { ReactionMenuStyles } from "./common/reaction-menu/ReactionMenu.styles";
import { ReactionPanelStyles } from "./common/reaction-panel/ReactionPanel.styles";
import { ReplyListStyles } from "./comment/reply-list/ReplyList.styles";
import { ReportMenuStyles } from "./common/report-menu/ReportMenu.styles";
import { ReportMenuSuperAppStyles } from "./common/report-menu/themes/superapp/ReportMenuSuperApp.styles";
import { SocialCommentClassNameContract } from "./SocialComment.classnames";
import { SortBoxStyles } from "./common/sort-box/SortBox.styles";
import { TypingUsersStyles } from "./comment/typing-users/TypingUsers.styles";
import { UserCardStyles } from "./comment/user-card/UserCard.styles";

/**
 * The Comment styles
 * @type {ComponentStyles<SocialCommentClassNameContract, DesignSystem>}
 */
export const SocialCommentStyle: ComponentStyles < SocialCommentClassNameContract, DesignSystem > = (config: DesignSystem) => ({
    ...CommonStyles(config),
    ...CommentStyles(config),
    ...ContentPanelStyles(config),
    ...CommentBoxStyles(config),
    ...CommentListStyles(config),
    ...CommentItemStyles(config),
    ...DisabledMessageStyles,
    ...ReplyListStyles(config),
    ...UserCardStyles(config),
    ...MiniReactionBreakdownStyles(config),
    ...ReactionMenuStyles(config),
    ...ReactionPanelStyles(config),
    ...ReportMenuStyles(config),
    ...SortBoxStyles(config),
    ...FollowButtonStyles,
    ...DeleteMenuMenuStyles(config),
    ...TypingUsersStyles(config),
    ...MostReactionsStyles(config),
    ...ProfileEducatorStyles(config),

    ...CommonSuperAppStyles(config),
    ...CommentSuperAppStyles(config),
    ...FollowButtonSuperAppStyles(config),
    ...ReportMenuSuperAppStyles(config)
});